import { render, staticRenderFns } from "./CommissionPlanSelector.vue?vue&type=template&id=4f6554ba&scoped=true&"
import script from "./CommissionPlanSelector.vue?vue&type=script&lang=js&"
export * from "./CommissionPlanSelector.vue?vue&type=script&lang=js&"
import style0 from "./CommissionPlanSelector.vue?vue&type=style&index=0&id=4f6554ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6554ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
